import React from 'react';
import StaticContent from 'components/StaticContent';
import withMainLayout from 'with/withMainLayout';

function AboutCookiesPage() {
  return <StaticContent src="/aboutcookies" />;
}

export default withMainLayout(AboutCookiesPage);
